import { TinyColor } from '@ctrl/tinycolor'; // Import TinyColor for color manipulation

// Removed the old PROJECT_COLORS array

// Simple string hash function (basic but better than charCodeAt(0))
const simpleHash = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

/**
 * Generates a visually distinct color based on a string ID (e.g., projectId).
 * Uses HSL color space for better distribution.
 * @param id The string ID.
 * @returns A hex color string (e.g., "#RRGGBB").
 */
export const getProjectColor = (id: string): string => {
  if (!id) return '#808080'; // Return neutral grey for null/empty ID

  const hash = simpleHash(id);
  
  // Use hash to generate HSL values
  const hue = hash % 360; // Hue range 0-359
  // Keep saturation and lightness within reasonable ranges for good visibility
  const saturation = 60 + (hash % 15); // Saturation 60-75%
  const lightness = 45 + (hash % 10); // Lightness 45-55%

  // Convert HSL to Hex using TinyColor
  const color = new TinyColor({ h: hue, s: saturation, l: lightness });
  return color.toHexString(); // Return #RRGGBB format
}; 